export {
  Expander,
  ANIMATION_DURATION,
} from './Expander';
